import Icon from '../components/Icon.vue'

Icon.register({
  spinner: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M304 48c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48zM256 416c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM464 208c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zM96 256c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48zM108.9 355.1c26.5 0 48 21.5 48 48 0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48zM403.1 355.1c26.5 0 48 21.5 48 48 0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48zM108.9 60.9c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48z'
      }
    ]
  }
})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/spinner.js